import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Utils } from '@/main/webapp/resources/src/vue/infrastructure/utils/helpers';
import CcImage from '@/main/webapp/resources/src/vue/domain/image/cc-image';
import CcPageProductComponent from '@/main/webapp/resources/src/vue/components/cc-page-product/cc-page-product';
import CcProductstock from '@/main/webapp/resources/src/vue/domain/productstock/cc-productstock';

@Component({
	filters: {
		imageUrl: (productStock: CcProductstock, image: CcImage) => {
			return ((image != null) ? `${Utils.getPermalik('/products/')}${productStock.product.code}/images/${image.name}?width=${CcPageProductComponent.PREVIEW_WIDTH}&height=${CcPageProductComponent.PREVIEW_HEIGHT}` : null);
		},
		decimal: (value: string) => {
			return new Intl.NumberFormat(navigator.language, { style: 'decimal', minimumFractionDigits: 2 }).format(parseFloat((parseFloat(value) || 0).toFixed(2)));
		},
		price: (value: string) => {
			return new Intl.NumberFormat(navigator.language, { style: 'currency', currency: 'EUR' }).format(parseFloat(value) || 0);
		},
		unit: (value: string, simple: boolean) => {
			const prefix: string = simple ? '' : 'al ';
			return ((value != null) ? `${prefix}${value.toLowerCase()}` : '');
		}
	}
})
export default class CcProductStockInformationsComponent extends Vue {
	@Prop({ type: Object, default: () => ({}) })
	private productStock!: CcProductstock;

	get averangePrice (): string {
		let contentUnitListPrice:number = 0;
		if (this.productStock) {
			const rule01: boolean = this.productStock.contentUnitListPrice && !this.productStock.onSale;
			const rule02: boolean = this.productStock.contentUnitSalePrice && this.productStock.onSale;

			contentUnitListPrice = rule01 ? this.productStock.contentUnitListPrice || 0 : rule02 ? this.productStock.contentUnitSalePrice || 0 : 0;
		}
		return this.$options.filters.price(contentUnitListPrice);
	}

	get averageWeight (): string {
		let averageWeight:string = this.productStock ? this.productStock.product.averageWeight ? this.productStock.product.averageWeight : null : null;
		return (averageWeight) ? this.$options.filters.decimal(averageWeight) : '';
	}

	get code (): string {
		return (this.productStock) ? this.productStock.product.code : '';
	}

	get contentQuantity (): number {
		return this.productStock ? this.productStock.product.contentQuantity ? this.productStock.product.contentQuantity : 0 : 0;
	}

	get contentUnit (): string {
		return this.productStock ? this.productStock.product.contentUnit ? this.productStock.product.contentUnit.toLowerCase() : '' : '';
	}

	get description (): string {
		return this.productStock ? this.productStock.product.customerDescription ? this.productStock.product.customerDescription : '' : '';
	}

	get itemsPerPackage (): number {
		return (this.productStock) ? this.productStock.product.itemsPerPackage ? this.productStock.product.itemsPerPackage : 0 : 0;
	}

	get salesDescription (): string {
		return this.productStock ? this.productStock.product.salesDescription ? this.productStock.product.salesDescription : '' : '';
	}

	get unitLowerCase (): string {
		return this.productStock ? this.productStock.product.unit ? this.productStock.product.unit.toLowerCase() : '' : '';
	}

	get unit (): string {
		return this.productStock ? this.productStock.product.customerUnit ? this.productStock.product.customerUnit : this.productStock.product.unit : '';
	}
}
